<template>
    <div v-if="displayHistory" class="p-2 history-card-log__container br flex ai-center">
        <div class="history-card-log__container-history-title">
            <div
                class="typographies-paragraph-small-black history-card-log__container-history-title__colors-common-text-subtle-default"
            >
                {{ $l10n.__('Historique') }}
            </div>
            <CompassIconButton icon="close" size="small" @click="closeHistory" />
        </div>
        <ul class="m-0">
            <li
                v-for="history in histories"
                :key="`${history.objectid}/${history.timestamp}`"
                class="history-card-log__item flex-row flex-start ai-center"
            >
                <div class="timeline-bullet__container prelative ai-center flex-row">
                    <div class="timeline-bullet__item br"></div>
                </div>
                <LogCard
                    class="ml-2 wp-10"
                    :linkedid="linkedid"
                    :linkedtype="linkedtype"
                    :oneLog="history"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import LogCard from './LogCard.vue';

export default {
    components: { LogCard },
    props: {
        histories: {
            type: Array,
            required: true,
        },
        displayHistory: {
            type: Boolean,
            required: true,
            default: false,
        },
        linkedid: {
            type: Number,
            required: true,
        },
        linkedtype: {
            type: String,
            required: true,
        },
    },
    methods: {
        closeHistory() {
            this.$emit('close-history');
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.history-card-log {
    &__item {
        height: 24px;
        &:not(:last-child) {
            .history-card-log__container:after {
                content: '';
            }
        }
        .timeline-bullet {
            &__item {
                height: 4px;
                width: 4px;
                background: $gray-80;
                margin-left: 6px;
                margin-right: 6px;
            }
            &__container {
                height: inherit;
                width: inherit;
                &:before {
                    content: '';
                    top: 0;
                }

                &:after {
                    bottom: 0;
                }
                &:before,
                &:after {
                    right: 7px;
                    background: $gray-40;
                    height: 6px;
                    width: 2px;
                    position: absolute;
                }
            }
        }
    }
    &__container {
        background: $gray-0;
        .cd-timeline-content {
            &-text {
                justify-content: space-between;
            }
            &--staff .compass-link__label {
                color: var(--colors-common-text-subtle-default);
                &:hover {
                    color: var(--colors-common-text-subtle-hover);
                }
            }
        }
    }
    &__container-history-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;

        &__colors-common-text-subtle-default {
            color: var(--colors-common-text-subtle-default);
        }
    }
}
</style>
